import React from "react";
import { IonCol, IonList, IonRadio, IonRadioGroup, IonRow } from "@ionic/react";
import "../styles/userTable.css";

const SubjectIdTable = (props) => {

    const { data, onRadioChange, disabled } = props;

    return (
        <IonList>
            <IonRadioGroup onIonChange={onRadioChange} disabled={disabled}>
                {Array.isArray(data) && data.map((item, idx) => {
                    return (
                        <IonRow key={item.thingId || idx} className="users-row">
                            <IonCol className="table-cell radio-button">
                                <IonRadio value={item.thingId.split(":")[1]} disabled={disabled} />
                            </IonCol>
                            <IonCol className="table-cell" >{item.thingId.split(":")[1]}</IonCol>
                        </IonRow>
                    );
                })}
            </IonRadioGroup>
        </IonList>
    );
}

export default SubjectIdTable;